import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ElementRef, OnDestroy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { fuseConfig } from 'app/fuse-config/index';
/** Data structure for holding telephone number. */
var TelNum = /** @class */ (function () {
    function TelNum(country, provider, phone) {
        this.country = country;
        this.provider = provider;
        this.phone = phone;
    }
    return TelNum;
}());
export { TelNum };
/** Custom `MatFormFieldControl` for telephone number input. */
var TelInputComponent = /** @class */ (function () {
    function TelInputComponent(formBuilder, _focusMonitor, _elementRef, ngControl) {
        var _this = this;
        this._focusMonitor = _focusMonitor;
        this._elementRef = _elementRef;
        this.ngControl = ngControl;
        this._required = false;
        this._disabled = false;
        this._readonly = false;
        this.stateChanges = new Subject();
        this.focused = false;
        // errorState = false;
        this.controlType = 'tel-input';
        this.id = "tel-input-" + TelInputComponent.nextId++;
        this.describedBy = '';
        this.countryCodes = [];
        this.phonePrefixes = [];
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._fuseConfig = fuseConfig;
        this.countryCodes = Object.keys(this._fuseConfig.settings.phonePrefixes);
        this.phonePrefixes = this._fuseConfig.settings.phonePrefixes;
        this.parts = formBuilder.group({
            country: [null, [Validators.required, Validators.minLength(2)]],
            provider: [null, [Validators.required, Validators.minLength(2)]],
            phone: [null, [Validators.required, Validators.minLength(4), Validators.minLength(6), Validators.maxLength(7), Validators.pattern(/^([+-]?[0-9]\d*|0)$/)]],
        });
        _focusMonitor.monitor(_elementRef, true).subscribe(function (origin) {
            if (_this.focused && !origin) {
                _this.onTouched();
            }
            _this.focused = !!origin;
            _this.stateChanges.next();
        });
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }
    Object.defineProperty(TelInputComponent.prototype, "empty", {
        get: function () {
            var _a = this.parts.value, country = _a.country, provider = _a.provider, phone = _a.phone;
            return !country && !provider && !phone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "shouldLabelFloat", {
        get: function () { return this.focused || !this.empty; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "errorState", {
        get: function () {
            return this.ngControl.errors !== null && !!this.ngControl.touched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "placeholder", {
        get: function () { return this._placeholder; },
        set: function (value) {
            this._placeholder = value;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            this._required = coerceBooleanProperty(value);
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "readonly", {
        get: function () { return this._readonly; },
        set: function (value) {
            this._readonly = coerceBooleanProperty(value);
            this._readonly ? this.parts.disable() : this.parts.enable();
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._disabled ? this.parts.disable() : this.parts.enable();
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelInputComponent.prototype, "value", {
        get: function () {
            if (this.parts.valid) {
                var _a = this.parts.value, country = _a.country, provider = _a.provider, phone = _a.phone;
                console.log(true);
                return country + provider + phone;
            }
            console.log(false);
            return null;
        },
        set: function (tel) {
            var countryCode = this.parts.get('country').value || '';
            var providerCode = this.parts.get('provider').value || '';
            var phoneNum = this.parts.get('phone').value || '';
            console.log(providerCode);
            if (tel) {
                if ((countryCode + providerCode + phoneNum).length > 7) {
                    tel = countryCode + providerCode + phoneNum;
                }
                if (this.countryCodes.indexOf(tel.substr(0, 2)) > -1) {
                    countryCode = tel.substr(0, 2);
                    providerCode = this.phonePrefixes[countryCode].indexOf(tel.substr(2, 2)) > -1 ? tel.substr(2, 2) : '';
                    phoneNum = tel.substr(4, tel.length);
                    if (this.countryCodes.indexOf(tel.substr(0, 3)) > -1) {
                        countryCode = tel.substr(0, 3);
                        providerCode = this.phonePrefixes[countryCode].indexOf(tel.substr(3, 2)) > -1 ? tel.substr(3, 2) : '';
                        phoneNum = tel.substr(5, tel.length);
                    }
                }
                else {
                    if (tel.length <= 7 && this.countryCodes.indexOf(tel.substr(0, 2)) === -1) {
                        countryCode = '';
                        providerCode = '';
                        phoneNum = tel;
                    }
                    else {
                        countryCode = tel.substr(0, 3);
                        if (this.phonePrefixes[countryCode]) {
                            providerCode = this.phonePrefixes[countryCode].indexOf(tel.substr(3, 2)) > -1 ? tel.substr(3, 2) : '';
                            phoneNum = this.phonePrefixes[countryCode].indexOf(tel.substr(3, 2)) > -1 ? tel.substr(5, tel.length) : tel.substr(3, tel.length);
                        }
                        else {
                            countryCode = '';
                            providerCode = '';
                            phoneNum = tel;
                        }
                    }
                }
                console.log('providerCode2: ' + providerCode);
            }
            console.log(countryCode + '-' + providerCode + '-' + phoneNum);
            // console.log(tel.length);
            // const { country, provider, phone } = tel || new TelNum('', '', '');
            // this.parts.setValue({ country, provider, phone });
            this.parts.controls['country'].setValue(countryCode);
            this.parts.controls['provider'].setValue(providerCode);
            this.parts.controls['phone'].setValue(phoneNum);
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    TelInputComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
        this._focusMonitor.stopMonitoring(this._elementRef);
    };
    TelInputComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    TelInputComponent.prototype.onContainerClick = function (event) {
        console.log('Click!');
        if (event.target.tagName.toLowerCase() !== 'input') {
            this._elementRef.nativeElement.querySelector('input').focus();
        }
    };
    TelInputComponent.prototype.writeValue = function (tel) {
        if (tel) {
            this.value = tel.country + tel.provider + tel.phone;
        }
        else {
            this.value = null;
        }
    };
    TelInputComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    TelInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    TelInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    TelInputComponent.prototype._handleInput = function () {
        this.onChange(this.value);
    };
    TelInputComponent.prototype.countryChanged = function () {
        console.log('Provider zeroed.');
        this.parts.controls['provider'].setValue('');
    };
    TelInputComponent.nextId = 0;
    return TelInputComponent;
}());
export { TelInputComponent };
